import React, { FC } from 'react';
import styles from './index.module.scss';
import { V2EnergyConservationEnergySavingPiePostResponse } from '@maxtropy/dmes-apis-v2';
import { keepTwoOrLine, keepTwoOrLinePercent, showSavingColor } from '../../utils';

interface ITotalEnergySavings {
  energySavingData?: V2EnergyConservationEnergySavingPiePostResponse;
}

const TotalEnergySavings: FC<ITotalEnergySavings> = props => {
  const { energySavingData } = props;
  return (
    <div className={styles.wrapper}>
      <div className={styles.left_box}>
        <div className={styles.label}>节能总量(kWh)</div>
        <div className={styles.value} style={{ color: showSavingColor(energySavingData?.energySavingTotalPower) }}>
          {keepTwoOrLine(energySavingData?.energySavingTotalPower)}
        </div>
      </div>
      <div className={styles.right_box}>
        <div className={styles.label}>环比</div>
        <div className={styles.value} style={{ color: showSavingColor(energySavingData?.rate) }}>
          {keepTwoOrLinePercent(energySavingData?.rate)}
        </div>
      </div>
    </div>
  );
};

export default TotalEnergySavings;
